import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const MetricCard = ({
  title,
  value,
  accent,
  icon,
}: {
  title: string
  value: string
  accent: "red" | "orange" | "green" | "blue" | "slate"
  icon: any
}) => {
  const accentClass = {
    red: "border-red-200 bg-red-50 text-red-700",
    orange: "border-orange-200 bg-orange-50 text-orange-700",
    green: "border-emerald-200 bg-emerald-50 text-emerald-700",
    blue: "border-blue-200 bg-blue-50 text-blue-700",
    slate: "border-slate-200 bg-slate-50 text-slate-700",
  }[accent]

  return (
    <div className={`rounded-xl border p-4 ${accentClass}`}>
      <div className="flex items-center gap-2 text-xs font-semibold uppercase">
        <FontAwesomeIcon icon={icon} />

        <span>{title}</span>
      </div>

      <p className="mt-2 text-lg font-bold">{value}</p>
    </div>
  )
}
